import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

export const authGuard = (): boolean => {
    if (!inject(AuthService).isAuthenticated()) {
        inject(Router).navigate(['/login'], { queryParams: { silent: 'true' } });
    }

    return true;
}